import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { AuthService } from '../../core/auth.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { LocalStorage } from '@ngx-pwa/local-storage';

export class ValidationService {
  static emailValidator(control) {
    // tslint:disable-next-line: max-line-length
    if (control.value.match(/[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/)) {
      return null;
    } else {
      return { invalidEmailAddress: true };
    }
  }
  static passwordValidator(control) {
    // {6,100}           - Assert password is between 6 and 100 characters
    // (?=.*[0-9])       - Assert a string has at least one number
    if (control.value.match(/^(?=.*[0-9])[a-zA-Z0-9!@#$%^&*]{4,100}$/)) {
      return null;
    } else {
      return { invalidPassword: true };
    }
  }
}

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  loginvalid: boolean;
  newloginform: FormGroup;
  submitted = false;
  ErrorMsg: string;
  ErrorShow: boolean;

  constructor(
    private meta: Meta,
    private title: Title,
    private router: Router,
    public authService: AuthService,
    private formBuilder: FormBuilder,
    private localStorage: LocalStorage,
  ) {
    this.ErrorShow = true;
    this.newloginform = this.formBuilder.group({
      email: ['', [Validators.required, ValidationService.emailValidator]],
      password: ['', [Validators.required, ValidationService.passwordValidator]],
      acceptTerms: [false, Validators.requiredTrue]
    });
    // this.authService.loginError.subscribe(error => {
    //   this.ErrorShow = false;
    //   this.ErrorMsg = error;
    //   setTimeout(() => {
    //     this.ErrorShow = true;
    //   }, 10000);
    // });
  }

  ngOnInit() {
    this.title.setTitle('Login - Massage Robotics');
    this.meta.updateTag({ name: 'Description', content: 'Massage Robotics' });
    this.meta.updateTag({ name: 'Keywords', content: 'Massage Robotics' });
  }
  onSubmit() {
    this.loginvalid = true;
    // this.router.navigate(['/profile']);

    this.submitted = true;
    if (this.newloginform.invalid) {
      this.loginvalid = false;
      return;
    }
    // console.log(JSON.stringify(this.newloginform.value));
    const email = this.newloginform.value.email;
    const password = this.newloginform.value.password;
    delete this.newloginform.value.acceptTerms;
    this.authService.login(email, password);
      let user = {
          "id": 202,
          "user_role": 3,
          "name": "Ashish Rastogi",
          "first_name": "Ashish",
          "last_name": "Rastogi",
          "email": "ashishd23@gmail.com",
          "country_id": 101,
          "state_id": 10,
          "city_id": null,
          "profile_pic": "202205137248881c2b75ac0d71f5eeabf46d439d.png",
          "email_verified_at": "2022-01-31T12:26:35.000000Z",
          "created_at": "2022-01-31T12:25:32.000000Z",
          "updated_at": "2022-06-21T13:11:57.000000Z",
          "industry_id": 3,
          "total_experience": "20",
          "linkedin_id": "https://www.linkedin.com/",
          "fb_id": "https://twitter.com/",
          "otp": null,
          "stripe_customer_id": "cus_LAtpRRWav3L5J3",
          "status": 1,
          "last_login": "2022-06-21 13:11:57",
          "token": "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiIxIiwianRpIjoiNThkMDg3OTlkMWVkNThiMjNjZDJhODI5ZDZlZjljYmJjMDNjMDY2ZTQyMGMyMDQ4NmM4NTYzYjhlZGViMDFkZWQxZmUwMGNlZmI4ZTNhOTciLCJpYXQiOiIxNjU1ODE3MTE3LjA2ODEyMyIsIm5iZiI6IjE2NTU4MTcxMTcuMDY4MTI3IiwiZXhwIjoiMTY1NTgyNDMxNi45NTU5NTIiLCJzdWIiOiIyMDIiLCJzY29wZXMiOltdfQ.JYo_FM1KRlNjlYD_wdilihthRmz8N33-S5wk_M1po59WGzxkwwdVLMRGQyENpG79Okn5P-AAp0gWThqST3ihpgvJ60YtttYHBd14kX3W0QcT6SFQKlIOeGEMS8PUHFXXMbz99f5DL422BPWGW0CM0ZrXxSCUHtQ5LYTUDQmPE0jgjENYZS0GvVJjTdC1Hum-0QBcdDqgYl6m9e73-R5PPK8wGnxsFgmpG9vBdjNHXyvDCiAVXbFORKh_5ZIkpX9Rv6quBnzS70WFmyImLDGgbebrGW7TvN5OO_FQV-UP4fP-4zue47-3R544mso5NwrlWn4nOGxqvDujRjSS5sPm8mS_e5NHlVUIW5vGZmkCVI02n4I-LSfGfYeEgxZBxclKTwVtyonb-qSceZcppsCGtAE3XGORw4IywBfix0dth0q9ITGZLb-Ae1V4Q7z0lxBeebhm6tSVZYdQ9iMUy6EclJABDojFUqZLZKP8W0pM6GFS_HD2unCdTX50XVwVOZ0-qN33nYycu19n1B_pCwaPTXxH0ytL9RJMcRIbXdjrOXmOucEjvXrlPFHEazh_NrNTc7uEKc0BxJXeuYf1Rs-NmhOaEoLCwt3VUw1gofS4m-wJLOvhYR0Z2ZrNC_GZS0Fhd02mduMr0JyR_6Vn5GELtsyAHvRiflzUeoBrHBTLxmQ",
          "profile_picture": "https://api.vttouch.com/images/user.png",
          "role_name": "User",
          "rate": 8.9,
          "coachRegistrationComplete": true
      }
      this.authService.setUser = user;
      this.router.navigate(['profile']);
    // this.authService.pyLogin(this.newloginform.value).subscribe((response: any) => {
    //   if (response.status == 1) {
    //     this.authService.setUser = response.data;
    //     this.router.navigate(['profile']);
    //   } else {
    //     this.loginvalid = false;
    //   }
    // }, error => {
    //   this.loginvalid = false;
    //   var errObjKeys = Object.keys(error.error.data);
    //   if (errObjKeys.length > 0) {
    //     console.log(error.error.data[errObjKeys[0]].join());
    //     this.ErrorShow = false;
    //     this.ErrorMsg = error.error.data[errObjKeys[0]].join();
    //   }
    // });

    // setTimeout(() => {
    //   this.loginvalid = false;
    // }, 1000);
  }
  get f() {
    return this.newloginform.controls;
  }

}
